var React = require('react');

function Gl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#d00c33","d":"M0 240h640v240H0zm80 0a160 160 0 1 0 320 0 160 160 0 0 0-320 0","key":1})]);
}

Gl.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gl;

Gl.default = Gl;
